module.exports = __webpack_public_path__ + "img/emotion-ethical.1c031ab.webp";